import { GetAppQr } from '~/components/ui/GetAppQr';
import { cn } from '~/lib/cn';

/**
 * "Download nsave" QR element (Figma Cards / Pay in a tap).
 * Row with a scannable QR (current origin + `/get-the-app`) on the left and a
 * bold label on the right. Desktop-only (hidden on small screens).
 */
export function DownloadQr({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'hidden items-center gap-5 rounded-none bg-white p-3 ring-1 ring-black-6 md:inline-flex',
        className,
      )}>
      <GetAppQr className="size-20 shrink-0" />
      <span className="pr-7 text-body font-semibold text-ink">Download nsave</span>
    </div>
  );
}
